import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSalesContext } from "../../Pages/SalesContext";
import SalesTrendHeader from "../../Pages/SalesTrendHeader";
import { jwtDecode } from "jwt-decode";
import React from "react";
import LeadershipdataComp from "./components/LeadershipdataComp";
import LeadershipTable from "./components/LeadershipTable";
import { API_BASE_URL } from "../../config/config";
import { useTokenFromQuery, useFetchUserDetails, getUserIdFromToken ,useResetRefreshTime } from "../../utils/dashboardUtils.js";

interface DecodedToken {
  name: string;
  preferred_username: string;
}
// const saveTokenWithExpiry = (token, expiryDays= 1) => {
//   const now = new Date().getTime();
//   const expiry = now + expiryDays * 24 * 60 * 60 * 1000;
//   const tokenData = {
//     value: token,
//     expiry,
//   };
//   localStorage.setItem("access_token", JSON.stringify(tokenData));
// };

// const getValidToken = () => {
//   const item = localStorage.getItem("access_token");
//   if (!item) return null;

//   try {
//     const { value, expiry } = JSON.parse(item);
//     const now = new Date().getTime();
//     if (now > expiry) {
//       console.warn("Token expired, removing from storage.");
//       localStorage.removeItem("access_token");
//       return null;
//     }
//     return value;
//   } catch (e) {
//     console.error("Error parsing token from storage:", e);
//     localStorage.removeItem("access_token");
//     return null;
//   }
// };

// const LeadershipDashboardmMR: React.FC = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { setKpiData } = useSalesContext();
//   const [refreshTime, setRefreshTime] = useState<string | undefined>(undefined);
//  const [userLoaction, setuserLocation] = useState(null);
//   const [headerUsername, setheaderUsername] = useState(null);
//   const [userdata ,setuserData] = useState<any>(null);
//   // Handle token from URL
//   useEffect(() => {
//     // const pathMatch = location.pathname.match(/access_token=([^/]+)/);
//      const queryParams = new URLSearchParams(location.search);
//      const queryToken = queryParams.get("access_token");
   
   
//     if (queryToken) {
//       saveTokenWithExpiry(queryToken);
//       console.log("Token from URL:", queryToken);
//       navigate("/app/kpi_leadership_dashboard_MR", { replace: true });
//     }
//   }, [location, navigate]);

//    const token = getValidToken();

//   let user_id = "";

//   if (token) {
//     console.log("Token:", token);
//     try {
//       const decoded = jwtDecode<DecodedToken>(token);
//       user_id = decoded?.preferred_username || "";
//       console.log("Decoded Token:", decoded);
//     } catch (e) {
//       console.error("Invalid token", e);
//     }
//   }
//  useEffect(() => {
//     const queryParams = new URLSearchParams(location.search);
//     const queryToken = queryParams.get("access_token");
//     const validToken = getValidToken();
// if (!validToken) return;
//     console.log("API_BASE_URL", queryToken)
//       fetch(
//         `${API_BASE_URL}User/UserDetails`, {
//           headers: {
//              'Authorization': `Bearer ${validToken}`,
//             'Content-Type': 'application/json',
//           },
//         })       
//         .then((response) => response.json())
//         .then((data) => {
//           setuserData(data.data);
//           console.log("User Data:", data.data);
//           setuserLocation(data?.data?.user_Location)
//           const rawTime = data?.data?.last_Refresh_Time;
//   const timeWithoutZ = rawTime?.endsWith('Z') ? rawTime.slice(0, -1) : rawTime;

//   // Format the time
//   let istTime = new Date(timeWithoutZ).toLocaleString('en-IN', {
//     timeZone: 'Asia/Kolkata',
//     year: 'numeric',
//     month: 'numeric',
//     day: 'numeric',
//     hour: 'numeric',
//     minute: 'numeric',
//     second: 'numeric',
//     hour12: true
//   });

//   // Convert am/pm to AM/PM
//   istTime = istTime.replace('am', 'AM').replace('pm', 'PM');

//   setRefreshTime(istTime);
//   setheaderUsername(data?.data?.username)
//         })
//         .catch((error) => {
//           console.error("Error fetching filter data:", error);
//         });
//     }, [location, navigate]);
//   useEffect(() => {
//     const result = new Date().toLocaleString();
//     const datePart = result.split(',')[0];
//     const fixedTime = '2:00 AM';
//     const currentTime = `${datePart}, ${fixedTime}`;
//     setRefreshTime(currentTime);
//     console.log("UserData:", userdata);
//   }, []);

//   return (
//     <div className="sales-trend-dashboard">
//       <div className="dashboard-container">
//         <SalesTrendHeader
//           title="KPI Dashboard"
//          userName={headerUsername}
//           location={userLoaction}
//           refreshTime={refreshTime}
//         />
//         <LeadershipdataComp  />
//         <LeadershipTable userData ={userdata}/>
//       </div>
//     </div>
//   );
// };

// export default LeadershipDashboardmMR;

const LeadershipDashboardMR: React.FC = () => {
  const { setKpiData } = useSalesContext();
  const [refreshTime, setRefreshTime] = useState<string | null>(null);
  const [userLocation, setUserLocation] = useState<string | null>(null);
  const [headerUsername, setHeaderUsername] = useState<string | null>(null);

  // ✅ Handle token and redirect
  useTokenFromQuery("/app/kpi_leadership_dashboard_MR");

  // ✅ Fetch user details
  const userData = useFetchUserDetails(
    setUserLocation,
    setHeaderUsername,
    setRefreshTime,
    API_BASE_URL,
    "LeadershipDashboardMR"
  );

  // ✅ Auto reset refresh time (2 AM logic)
  useResetRefreshTime(setRefreshTime);

  // ✅ Decode token for user_id
  const user_id = getUserIdFromToken();

  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="KPI Dashboard"
          userName={headerUsername}
          location={userLocation}
          refreshTime={refreshTime}
        />
        <LeadershipdataComp />
        <LeadershipTable userData={userData} />
      </div>
    </div>
  );
};

export default LeadershipDashboardMR;

